/**
 * This module contains code for State Parameters.
 *
 * See [[ParamDeclaration]]
 * @module params
 * @preferred doc
 */
/** for typedoc */
export * from "./interface";
export * from "./param";
export * from "./paramTypes";
export * from "./stateParams";
export * from "./type";



/** WEBPACK FOOTER **
 ** ./params/module.ts
 **/